import { render, staticRenderFns } from "./FiltrosReaberta.vue?vue&type=template&id=245a9f60&scoped=true&"
import script from "./FiltrosReaberta.vue?vue&type=script&lang=js&"
export * from "./FiltrosReaberta.vue?vue&type=script&lang=js&"
import style0 from "./NavBar/style.css?vue&type=style&index=0&id=245a9f60&scoped=true&lang=css&"
import style1 from "./FiltrosReaberta.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a9f60",
  null
  
)

export default component.exports